import { render, staticRenderFns } from "./TabCategoryService.vue?vue&type=template&id=7cbdb211&"
import script from "./TabCategoryService.vue?vue&type=script&lang=js&"
export * from "./TabCategoryService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports